export const libros = {
  1: {
    num: 1,
    titulo: 'Mujeres y poder',
    autor: 'Mary Beard',
    enlace: 'https://www.planetadelibros.com/libro-mujeres-y-poder/262488',
    editorial: 'Editorial Crítica'
  },
  2: {
    num: 2,
    titulo: '¡Viva el latín!, historia y belleza de una lengua inútil',
    autor: 'Nicola Gardini',
    enlace: 'https://www.planetadelibros.com/libro-viva-el-latin/257311',
    editorial: 'Editorial Crítica'
  },
  3: {
    num: 3,
    titulo: 'La muerte de los héroes',
    autor: 'Carlos García Gual',
    enlace: 'http://www.turnerlibros.com/book/la-muerte-de-los-heroes.html',
    editorial: 'Turner'
  },
  4: {
    num: 4,
    titulo: 'La lengua de los dioses',
    autor: 'Andrea Marcolongo',
    enlace: 'https://www.megustaleer.com/libros/la-lengua-de-los-dioses/MES-085824/fragmento/',
    editorial: 'Penguin Random House'
  }
  };




// WEBPACK FOOTER //
// ./src/data/libros.js